// Appends width + quality + modern-format params to Unsplash URLs.
// Non-Unsplash URLs (uploaded WebP files, local assets) are returned untouched.
export function optImg(url, width = 1600, quality = 74) {
  if (!url || typeof url !== "string") return url;
  if (!url.includes("images.unsplash.com")) return url;
  try {
    const u = new URL(url);
    u.searchParams.set("w", String(width));
    u.searchParams.set("q", String(quality));
    u.searchParams.set("auto", "format");
    u.searchParams.set("fit", "crop");
    u.searchParams.delete("fm");
    u.searchParams.delete("dpr");
    return u.toString();
  } catch (e) {
    return url;
  }
}
